// extracted by mini-css-extract-plugin
export var checkbox = "_9h-0";
export var circle = "_9h-3";
export var horizontalContainer = "_9h-7";
export var sm = "_9h-5";
export var switch0 = "_9h-2";
export var switchDisabled = "_9h-8";
export var switchEnabled = "_9h-1";
export var textSwitchContainer = "_9h-9";
export var textSwitchOption = "_9h-a";
export var textSwitchOptionSelected = "_9h-b";
export var verticalContainer = "_9h-6";
export var xs = "_9h-4";